import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { NavItem, UncontrolledTooltip } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCoins } from '@fortawesome/free-solid-svg-icons'
import 'animate.css'
import { markRewardsNotificationsRead } from '../../helpers/api/rewards'
import { formatNumber } from './rewardsUtils'
import { REWARDS_ROUTE } from './rewardsNotifications'
import { useRewardsNotificationSettings, useUnreadRewardsNotifications } from './useRewardsNotifications'

// HO-TASK-290: "+58 HC" en la barra superior cuando el propietario ganó Coins
// que todavía no vio (avisos `rewards-points` sin leer: pago aprobado, bono,
// acelerador o referido). Al tocarlo lleva a Rewards y marca esos avisos como
// leídos, con lo que desaparece. Se vuelve a consultar al volver a la pestaña.
const RewardsCoinsBadge = () => {
  const history = useHistory()
  const { role, property, hasMultipleProperties, token } = useSelector((state) => state.auth.user) || {}
  const { selectedProperty } = useSelector((state) => state.property)
  const active = role === 'property' && !!token && !(hasMultipleProperties && !selectedProperty)
  const propertyId = selectedProperty || property || null

  const { enabled } = useRewardsNotificationSettings(active)
  const { items, mutate } = useUnreadRewardsNotifications('rewards-points', { active: active && enabled, limit: 20, maxAgeDays: 7, propertyId })
  const [opening, setOpening] = useState(false)

  const earned = items.reduce((total, notification) => total + (Number(notification.payload.hc) || 0), 0)
  if (!active || !enabled || earned <= 0) return null

  const open = async () => {
    setOpening(true)
    history.push(REWARDS_ROUTE)
    try {
      await markRewardsNotificationsRead(items.map((notification) => notification.id))
    } catch (error) {
      // Si no se pudo marcar, el badge sigue visible y se reintenta en el próximo clic.
    } finally {
      setOpening(false)
      mutate()
    }
  }

  return (
    <NavItem className="d-flex align-items-center mr-2">
      <button
        type="button"
        id="rewards-coins-badge"
        className="badge badge-soft-success rounded-capsule border-0 d-flex align-items-center px-2 py-1 fs--1 cursor-pointer animate__animated animate__bounceIn"
        onClick={open}
        disabled={opening}
        aria-label={`Ganaste ${formatNumber(earned, 2)} Homelan Coins. Ver mis Rewards`}
      >
        <FontAwesomeIcon icon={faCoins} className="mr-1" />+{formatNumber(earned, 2)}
        <span className="d-none d-sm-inline ml-1">HC</span>
      </button>
      <UncontrolledTooltip target="rewards-coins-badge" placement="bottom">
        Homelan Coins que ganaste con tus últimos pagos. Toca para verlas.
      </UncontrolledTooltip>
    </NavItem>
  )
}

export default RewardsCoinsBadge
